/*
FooterView.js
底部的输入栏
 */

import React, {useState} from 'react';
import {Row, Col, message} from 'antd';
import {Sender} from '@ant-design/x';


import askPoint5 from "../../NetComponents/askPoint5";
import {ACTIVE_SESSION_DEFAULT_VALUE, ACTIVE_SESSION_KEY} from "../../Common/constants";
import {addSessionMessages} from "../../Model/IndexedDB";


const FooterView = ({onRequest, loading, handleSendQuery, handleChatCancel}) => {
    // 输入框默认的值
    const [content, setContent] = useState('');

    // 提交query
    const onsubmit = (value) => {
        // setLoading(true);
        const sessionID = sessionStorage.getItem(ACTIVE_SESSION_KEY);
        if (sessionID === ACTIVE_SESSION_DEFAULT_VALUE) {
            message.error('未获取到相关会话信息').then();
            return;
        }
        onRequest(value);
        handleSendQuery(value);
        const messageItem = {
            id: 0,
            message: value,
            status: 'local',
        }
        addSessionMessages(sessionID, messageItem).then(() => {
            setContent('');
        });
    };

    return (
        <Row justify='center' align='middle'>
            <Col xs={24} sm={24} md={24} lg={13} xl={13}>
                <Sender placeholder='给"点五"发送消息'  value={content} onSubmit={onsubmit} loading={loading}
                        onCancel={handleChatCancel} onChange={setContent} style={{width: '100%'}}/>
                <div style={{color: '#fff', fontSize: '1px'}}>京ICP备06013390号-6</div>
            </Col>
        </Row>
    );
};

export default FooterView;